import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3343_3767)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.875 9.79297V10.7353C0.875 11.2351 1.07356 11.7145 1.42699 12.0679C1.78043 12.4213 2.25978 12.6199 2.75962 12.6199H11.2404C11.7402 12.6199 12.2196 12.4213 12.573 12.0679C12.9264 11.7145 13.125 11.2351 13.125 10.7353V9.79297",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.64429 6.02441L7.00006 9.16544L9.35583 6.02441",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7 8.85096L7 1.3125",
				stroke: "#002E5F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3343_3767",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgDownload);
export default ForwardRef;
